<div class="date-picker-header">
  <div class="datepicker-header-period-button" (click)="currentPeriodClicked()">
    <div class="button-text">{{ periodButtonText }}</div>
    @if (calendar.currentView !== 'month') {
      <i [nimbusIcon]="icons.CHEVRON_UP_LIGHT"></i>
    } @else {
      <i [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT"></i>
    }
  </div>

  <div class="flex-space"></div>

  <div class="date-picker-header-next-previous-button">
    <i [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT" class="button-item" [class.disabled]="!previousEnabled()" (click)="previousClicked()"></i>
    <i [nimbusIcon]="icons.CHEVRON_UP_LIGHT" class="button-item" [class.disabled]="!nextEnabled()" (click)="nextClicked()"></i>
  </div>
</div>
